<template>
  <span>
    <span class="material-icons-round mr-2 align-text-bottom" aria-hidden="true">build</span>Specially Designed Instructional Strategies
  </span>
</template>
